import { browserName, browserVersion } from 'react-device-detect';

import { getActiveProgressText } from '@/components/ProgressBar';
import { store } from '@/context/store';
import { getSessionId } from '@/utils/localStorage';

import { postUrl } from '../fetch';

import { CustomerRecordInterface } from './customerRecordType';
import { extractLastWord, extractScreen, extractType } from './helper';
import { TrackingRequest } from './TrackingRequest';

export async function uniqueIdTransfer(
    customerRecordObject: CustomerRecordInterface
): Promise<void> {
    const state = store.getState();

    const partnerId = state.displayReducer.partner.id;

    const garbageRegex = new RegExp(
        `^(?=.*(?:<\\w+|alert|script|union|select|passwd|system\\.ini|\\.owasp\\.org|win\\.ini|response\\.write|set-cookie|print|cat |etc|type|sleep|timeout|src=x|onerror|prompt|;|{|%|\\$\\{|www\\.google\\.com|\\d{4,})).*$`
    );

    // Check if partnerId or partnerName matches the garbage regex
    if (garbageRegex.test(partnerId)) {
        console.log('Potential security threat detected. Aborting operation.');
        console.log(
            'garbageRegex.test(partnerId)',
            partnerId,
            garbageRegex.test(partnerId)
        );
        console.warn('Potential security threat detected. Aborting operation.');
        return;
    }

    // user information
    const financeType = state.borrowerReducer.loan.financeType;
    const userFlow = state.displayReducer.partner.userFlow;
    const condition = state.borrowerReducer.vehicle.condition;
    const selectedLender = state.borrowerReducer.selectedLender;
    const parentScreen = getActiveProgressText();
    const sessionId = getSessionId();

    let status = 'In Progress';
    if (state.borrowerReducer.application.isDeclined) {
        status = 'Declined';
    }
    if (state.borrowerReducer.application.isSubmitted) {
        status = 'Submitted';
    }
    if (state.borrowerReducer.application.isPreApproved) {
        status = 'Pre Approved';
    }

    const url = `/api/tracking`;

    const location = window.location.href;
    let type = 'unknown';
    if (location.includes('localhost')) {
        type = 'test';
    } else if (location.includes('vroom') || location.includes('youx')) {
        if (
            !(
                location.includes('demo') ||
                location.includes('dev') ||
                location.includes('uat')
            )
        ) {
            type = 'iframe';
        } else {
            type = 'test';
        }
    } else {
        type = 'codesnippet';
    }

    const extendedCustomerRecord: CustomerRecordInterface = {
        ...customerRecordObject,
        instanceData: {
            name: 'Vroom',
            webApplication: {
                name: 'Vroom',
                type,
            },
            partnerDetails: {
                id: partnerId,
            },
            journey: userFlow,
        },
        applicationData: {
            ...customerRecordObject.applicationData,
            status,
            label: extractLastWord(customerRecordObject.applicationData?.id),
            type: extractType(
                customerRecordObject.applicationData?.id ?? 'none'
            ),
            screen: extractScreen(customerRecordObject.applicationData?.id),
            parentScreen,
            finance: {
                type: financeType,
                subtype: condition,
            },
            lenderDetails: {
                id: selectedLender?.matchingEngineLenderId,
                selected: selectedLender?.lenderName,
            },
        },
        userDevice: {
            browser: browserName,
            os: browserVersion,
            size: `${window.innerWidth}x${window.innerHeight}`,
        },
        sessionId,
    };

    const bannedScreens = ['quickCalculator', 'returnUser'];
    const allowedInteractionTypes = ['visibleOnScreen'];
    // Remove the first screen visible event
    if (
        bannedScreens.includes(
            extendedCustomerRecord.applicationData?.screen || ''
        )
    ) {
        return;
    }
    if (!allowedInteractionTypes.includes(extendedCustomerRecord.eventType || '')) {
        return;
    }
    const realPartnerId = state.displayReducer.partner.partnerId;

    const trackingRequest: TrackingRequest = {
        sessionId,
        partnerId: realPartnerId ?? '',
        userId: state.borrowerReducer.personalDetails.mobilePhone,
        storeId: state.displayReducer.partner.partnershipConfigId ?? '',
        brandId: state.displayReducer.partner.brandId ?? '',
        organisationId: state.displayReducer.partner.organisationId ?? '',
        interaction: {
            timestamp: new Date(),
            screen: extendedCustomerRecord.applicationData?.screen || '',
            type: extendedCustomerRecord.eventType ?? '',
        },
        userAgent: navigator.userAgent,
    };

    const trackingUrl = `/api/tracking2`;

    void postUrl(trackingUrl, trackingRequest);

    // We are limiting the data sent to the backend to only the visibleOnScreen events
    if (extendedCustomerRecord.eventType !== 'visibleOnScreen') return;

    void postUrl(url, extendedCustomerRecord);
}
